export default __webpack_public_path__ + "static/heels3.inspirations-f82277abaa3590ca35caa67163295528.jpg";